var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.1 18.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b8d2d3",
    d: "M9.44,10.6,10,7.19H6.69V5A1.7,1.7,0,0,1,8.61,3.14H10.1V.23A18.17,18.17,0,0,0,7.46,0C4.76,0,3,1.63,3,4.59v2.6H0V10.6H3v8.25H6.69V10.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookF);
export default __webpack_public_path__ + "static/media/facebook-f.0a3ca13bfab98df099ad88c7bac6f2fd.svg";
export { ForwardRef as ReactComponent };